import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ExportModal = ({ onClose, dateRange }) => {
  const [exportType, setExportType] = useState('revenue');
  const [format, setFormat] = useState('pdf');
  const [isExporting, setIsExporting] = useState(false);

  const exportTypes = [
    { id: 'revenue', label: 'Revenue Report', description: 'Complete revenue breakdown with charts' },
    { id: 'games', label: 'Game Performance', description: 'Individual game metrics and statistics' },
    { id: 'payouts', label: 'Payout History', description: 'Transaction history and payment details' },
    { id: 'insights', label: 'Performance Insights', description: 'Analytics and demographic data' }
  ];

  const formats = [
    { id: 'pdf', label: 'PDF', description: 'Professional formatted report' },
    { id: 'csv', label: 'CSV', description: 'Spreadsheet compatible data' },
    { id: 'xlsx', label: 'Excel', description: 'Microsoft Excel workbook' }
  ];

  const handleExport = async () => {
    setIsExporting(true);
    
    // Simulate export process
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setIsExporting(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl font-semibold text-foreground">Export Report</h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div>
            <label className="text-sm font-medium text-foreground mb-3 block">Report Type</label>
            <div className="space-y-2">
              {exportTypes.map((type) => (
                <div key={type.id} className="flex items-start space-x-3">
                  <input
                    type="radio"
                    id={type.id}
                    name="exportType"
                    value={type.id}
                    checked={exportType === type.id}
                    onChange={(e) => setExportType(e.target.value)}
                    className="mt-1"
                  />
                  <label htmlFor={type.id} className="flex-1 cursor-pointer">
                    <div className="font-medium text-foreground">{type.label}</div>
                    <div className="text-sm text-muted-foreground">{type.description}</div>
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-3 block">Export Format</label>
            <div className="space-y-2">
              {formats.map((fmt) => (
                <div key={fmt.id} className="flex items-start space-x-3">
                  <input
                    type="radio"
                    id={fmt.id}
                    name="format"
                    value={fmt.id}
                    checked={format === fmt.id}
                    onChange={(e) => setFormat(e.target.value)}
                    className="mt-1"
                  />
                  <label htmlFor={fmt.id} className="flex-1 cursor-pointer">
                    <div className="font-medium text-foreground">{fmt.label}</div>
                    <div className="text-sm text-muted-foreground">{fmt.description}</div>
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="p-4 bg-muted/20 rounded-lg">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="Calendar" size={16} className="text-muted-foreground" />
              <span className="text-sm font-medium text-foreground">Date Range</span>
            </div>
            <p className="text-sm text-muted-foreground">
              {dateRange === '7d' && 'Last 7 days'}
              {dateRange === '30d' && 'Last 30 days'}
              {dateRange === '90d' && 'Last 90 days'}
              {dateRange === '1y' && 'Last year'}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between p-6 border-t border-border">
          <button
            onClick={onClose}
            className="px-4 py-2 text-muted-foreground hover:text-foreground transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleExport}
            disabled={isExporting}
            className="flex items-center space-x-2 px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50"
          >
            {isExporting ? (
              <>
                <Icon name="Loader2" size={16} className="animate-spin" />
                <span>Exporting...</span>
              </>
            ) : (
              <>
                <Icon name="Download" size={16} />
                <span>Export Report</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportModal;